import { Field } from "formik";
import * as Yup from "yup";

import {
  MessagingStrategyName,
  OwnedPhoneNumberPoolType,
} from "~frontend/__generated__/graphql";

import OwnedPhoneNumberPoolPicker from "./common/OwnedPhoneNumberPoolPicker";
import {
  MessagingStrategyConfigComponent,
  OwnedPhoneNumberPool,
} from "./types";

const FakePoolMessagingStrategyConfig: MessagingStrategyConfigComponent<MessagingStrategyName.FakePool> =
  {
    Component: props => {
      const allOwnedPhoneNumberPools: OwnedPhoneNumberPool[] = props.readOnly
        ? []
        : props.ownedPhoneNumberPools || [];

      const showPicker = allOwnedPhoneNumberPools?.length != 1;

      const ownedPhoneNumberPoolsToShow: OwnedPhoneNumberPool[] = props.readOnly
        ? [props.savedConfig.ownedPhoneNumberPool as OwnedPhoneNumberPool]
        : allOwnedPhoneNumberPools.filter(
            p => p.type === OwnedPhoneNumberPoolType.Fake
          );

      return showPicker ? (
        <OwnedPhoneNumberPoolPicker
          readOnly={props.readOnly}
          name="messagingStrategy.config.ownedPhoneNumberPoolId"
          ownedPhoneNumberPools={ownedPhoneNumberPoolsToShow}
        />
      ) : (
        <Field
          type="hidden"
          name="messagingStrategy.config.ownedPhoneNumberPoolId"
          value={allOwnedPhoneNumberPools[0].id}
        />
      );
    },
    configValidationSchema: Yup.object().shape({
      ownedPhoneNumberPoolId: Yup.string().required("Required"),
    }),
    formValuesToConfigInput: vals => vals,
    campaignConfigToFormValues: config => ({
      ownedPhoneNumberPoolId: config.ownedPhoneNumberPool.id || "",
    }),
    defaultFormValues: ({ ownedPhoneNumberPools }) => {
      return {
        ownedPhoneNumberPoolId:
          ownedPhoneNumberPools.filter(
            p => p.type === OwnedPhoneNumberPoolType.Fake
          )[0]?.id ?? "",
      };
    },
  };

export default FakePoolMessagingStrategyConfig;
